/**
 * created by cc 批量图上传
 * 2016-3-30
 *last modified by lileilei 2018.3.15
 */
'use strict';
angular.module('atlasMultiImagesUploaderModule', []).controller('multiImgsUpladerCtrl', [
    '$scope',
    'modalDialog',
    '$timeout',
    '$modalInstance',
    '$q',
    '$modal',
    'specialCase',
    'trsHttpService',
    'finishFiles',
    'showAddPersonalMaterial',
    'getFileMD5Service',
    function(
        $scope,
        modalDialog,
        $timeout,
        $modalInstance,
        $q,
        $modal,
        specialCase,
        trsHttpService,
        finishFiles,
        showAddPersonalMaterial,
        getFileMD5Service
    ) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                lockBtn: false,
                showAddIcon: false, //显示添加图标
                isShowRoutes: false, //是否显示路径和上一级按钮
                isAddPersonalMaterial: true, //是否添加到个人素材库
                showAddPersonalMaterial: angular.isDefined(showAddPersonalMaterial) ? showAddPersonalMaterial : false, //是否展示添加到个人素材库的选项
            };
            $scope.page = {
                ITEMCOUNT: '0',
                CURRPAGE: '1',
                PAGESIZE: '18',
                PAGECOUNT: '1',
            };
            $scope.data = {
                navs: angular.isDefined(specialCase)
                    ? [{ name: '本地图片', value: '2' }]
                    : [
                          { name: '我的图片', value: '1' },
                          { name: '本地图片', value: '2' },
                      ],
                myPictures: [], //我的图片列表
                selectedArray: [], //我的图片选中图片
                currFileId: '0', //当前文件夹的id
                keywords: '', //检索关键词
                uploadImgs: angular.isArray(finishFiles) ? finishFiles : [],
                uploadedSrcs: [],
                progress: angular.isArray(finishFiles)
                    ? (function() {
                          var obj = {};
                          for (var i in finishFiles) {
                              var _obj = finishFiles[i];
                              obj[_obj.id] = '100%';
                          }
                          return obj;
                      })()
                    : {},
                proGress: {},
                localPic: [],
                errorNameArr: [],
            };
            $scope.params = {
                serviceid: 'mlf_releaseSource', //服务名
                methodname: 'queryPersonalMaterials', //方法名
                PersonalMaterialId: '0', // 主键，唯一性
                status: '0', //正常
                fileType: '2', //数据类型
                order: '0', //0：按创建时间排序，1：显示名称排序
                searchValue: '', //搜索内容
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            //920
            $scope.data.selectedNav = $scope.data.navs[0].value;
            initInputFile();
        }
        /**
         * [getAutoHeight description] 居中提示文字
         * @return {[type]} [description]
         */
        // $scope.getAutoHeight = function() {
        //     $timeout(function() {
        //         var bodyHeight = $(".publicModal .body").height(),
        //             fixedAreaHeight = $(".fixedArea").height();
        //         var contentHeight = bodyHeight - fixedAreaHeight;
        //         $(".uploadContent.localUpload").height(contentHeight);
        //     }, 500);
        // };
        /**
         * [getContentHeight description] 控制content内容的高度
         * @return {[type]} [description]
         */
        function getContentHeight() {
            $timeout(function() {
                if ($scope.data.uploadImgs.length == 0) {
                    var hei;
                    var bodyHei = $('.publicModal .body').height();
                    hei = bodyHei - $('.fixedArea').height();
                    $('.uploadContent.localUpload').css({ height: hei + 'px' });
                } else {
                    $('.uploadContent.localUpload').css({ height: 'auto' });
                }
            });
        }

        /**
     
     * @return {[type]} [description]
     */
        function initData() {
            requestData();
            $scope.callBack = {
                success: function(file, src) {
                    for (var i = 0; i < $scope.data.uploadImgs.length; i++) {
                        if (file.id == $scope.data.uploadImgs[i].id) {
                            getuploaderData(src, file, i).then(function(data) {
                                if ($scope.data.uploadImgs.length === data.length) {
                                    // return;
                                } else {
                                    return;
                                }
                                // if ($scope.data.uploadImgs.length === data.length) {
                                //     addMyPictures(data);
                                // } else {
                                //     return;
                                // }
                            });
                        }
                    }
                    getContentHeight();
                },
                error: function(file) {
                    //$modalInstance.dismiss();
                },
                file: function(file, uploader) {
                    angular.forEach(file, function(value, key) {
                        $scope.data.uploadImgs.push({
                            id: value.id,
                            appsort: parseInt(value.id.substring(8)),
                            size: value.size,
                        });
                        (function(index) {
                            uploader.makeThumb(value, function(error, src) {
                                $scope.data.uploadImgs[index].src = src;
                            });
                        })(key);
                        if ($scope.data.uploadImgs.length === file.length) {
                            $scope.data.uploadImgs.sort(function(x, y) {
                                return x.appsort > y.appsort ? 1 : -1;
                            });
                        }
                    });
                },
                tar: function(file, percentage) {
                    var per = Math.ceil(percentage * 100) + '%';
                    $timeout(function() {
                        $scope.data.progress[file.id] = per;
                        $scope.data.proGress[file.id] = Math.ceil(percentage * 100);
                    });
                },
                comp: function(file) {},
                start: function(file) {
                    $scope.data.errorNameArr = [];
                    $scope.theFinish = function() {
                        uploader.upload();
                    };
                },
                finish: function() {
                    if ($scope.data.errorNameArr.length > 0) {
                        var errorNameArr = $scope.data.errorNameArr.join(',');
                        modalDialog.alertType('文件' + errorNameArr + '上传失败！', '', 'error', 'confirm');
                    }
                },
            };
            getFileMD5Service.init();
        }

        /**
         * [deletePic 删除图片]
         * @return {[int]} index [description] //删除图片的序号
         */
        $scope.deletePic = function(index) {
            $scope.data.uploadImgs.splice(index, 1);
            $scope.data.uploadedSrcs.splice(index, 1);
            getContentHeight();
        };

        /**
         * [uploadends] 上传是否正在进行
         * @return {[type]} [description]
         */
        $scope.uploadIsRunning = function() {
            var flag = false;
            for (var i in $scope.data.progress) {
                if ($scope.data.progress[i] !== undefined && $scope.data.progress[i] !== '100%') flag = true;
            }
            return flag;
        };
        /**
         * [getAllPercent] 获取总体上传进度
         * @return {[type]} [description]
         */
        $scope.getAllPercent = function() {
            var percent = 0;
            for (var i in $scope.data.proGress) {
                var picFile = $scope.data.proGress[i];
                if (picFile !== undefined) {
                    percent += picFile / $scope.data.uploadImgs.length;
                }
            }
            $scope.percent = Math.round(percent);
            return Math.round(percent) + '%';
        };
        /**
         * [requestData description] 请求我的图片数据
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                //9080
                $scope.data.myPictures = data.DATA;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT; //页数
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT; //文件数量
                getFileRoutes();
            });
        }
        /**
         * [getFileRoutes description] 获取当前文件的导航
         * @return {[type]} [description]
         */
        function getFileRoutes() {
            if ($scope.data.currFileId == '0') {
                $scope.status.isShowRoutes = false;
                return;
            } else {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'getPersonalMaterialDaoHang',
                    PersonalMaterialId: $scope.data.currFileId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var tempArray = [];
                    var ellipsisTitle = '';
                    //导航长度大于3时，截取中间部分的导航串
                    for (var i = data.length - 1; i >= 0; i--) {
                        if (data.length > 3 && i < data.length && i > 0) {
                            ellipsisTitle += i == data.length - 1 ? data[i].FILEDESC : '>' + data[i].FILEDESC;
                        }
                        data[i].fileTitle = data[i].FILEDESC;
                        tempArray.push(data[i]);
                    }
                    //添加根目录
                    $scope.data.routes = [
                        {
                            FILEDESC: '全部文件',
                            PERSONALMATERIALID: '0',
                            fileTitle: '全部文件',
                        },
                    ].concat(tempArray);
                    $scope.data.allRoutes = angular.copy($scope.data.routes);
                    $scope.status.isShowRoutes = true;
                    var num = 0;
                    var last = false;
                    adjustWidth(num, last); //若路径宽度超出最大宽度500px则调整
                });
            }
        }
        //若路径宽度超出最大宽度500px则调整
        function adjustWidth(num, last) {
            $timeout(function() {
                if (angular.element('.searchBreadNav').width() > 500) {
                    if (num == $scope.data.routes.length - 1 && !last) {
                        //如果前面几个路径省略后宽度依然超出，则缩短最后一个
                        $scope.data.routes[num].FILEDESC = $scope.data.routes[num].FILEDESC.substring(0, 5) + '...';
                        last = true;
                        adjustWidth(num, last);
                    }
                    if (num > $scope.data.routes.length - 1) return;
                    $scope.data.routes[num].FILEDESC = '...';
                    if (num == $scope.data.routes.length - 1) {
                        num = $scope.data.routes.length - 1;
                        var mergenum = 1;
                        mergeBreadnav(mergenum);
                        return;
                    } else {
                        num++;
                    }
                    adjustWidth(num, last);
                } else {
                    return;
                }
            }, 20);
        }

        function mergeBreadnav(mergenum) {
            $timeout(function() {
                if (angular.element('.searchBreadNav').width() > 500) {
                    var tempArray = [];
                    var ellipsisTitle = '',
                        materialid = '';
                    var data = $scope.data.routes;
                    if (data.length === 1) return;
                    if (data.length === 2) {
                        for (var i = 0; i < mergenum + 1; i++) {
                            ellipsisTitle += data[i].fileTitle + '>';
                            materialid += data[i].PERSONALMATERIALID + ',';
                        }
                        materialid = materialid.substring(0, materialid.length - 1);
                    } else {
                        for (var i = 0; i < mergenum + 1; i++) {
                            ellipsisTitle += data[i].fileTitle + '>';
                        }
                    }
                    ellipsisTitle = ellipsisTitle.substring(0, ellipsisTitle.length - 1);
                    $scope.data.routes.splice(0, mergenum + 1, {
                        //点击...的时候调到根目录
                        FILEDESC: '... ...',
                        PERSONALMATERIALID: $scope.data.routes.length === 2 ? materialid : $scope.data.routes[mergenum].PERSONALMATERIALID,
                        fileTitle: ellipsisTitle,
                    });
                    mergeBreadnav(mergenum);
                } else {
                    return;
                }
            }, 20);
        }
        /**
         * [turnBackToPreviousRoute description] 返回上一级目录
         * @return {[type]} [description]
         */
        $scope.turnBackToPreviousRoute = function(currentRoute) {
            var routesLength = $scope.data.routes.length;
            if (routesLength === 1) {
                //在路径被合并为一条的时候
                var allId = $scope.data.routes[0].PERSONALMATERIALID.split(','),
                    lastPERSONALMATERIALID = allId[allId.length - 2];
                var route = {
                    PERSONALMATERIALID: lastPERSONALMATERIALID, //把上一条的id存起来
                };
            } else {
                var route = $scope.data.routes[routesLength - 2];
            }
            var lastRoute = $scope.data.routes[routesLength - 1];
            if (currentRoute == 0) {
                turnBack(route);
            } else if (lastRoute.PERSONALMATERIALID != currentRoute.PERSONALMATERIALID) {
                turnBack(currentRoute);
            }
        };
        /**
         * [turnBackToAllFile description] 返回全部文件
         * @return {[type]} [description]
         */
        $scope.turnBackToAllFile = function() {
            var route = $scope.data.routes[0];
            turnBack(route);
        };
        /**
         * [turnBack description] 返回指定目录
         * @param  {[type]} route [description] 指定目录
         * @return {[type]}       [description]
         */
        function turnBack(route) {
            $scope.params.searchValue = '';
            $scope.data.keyWords = $scope.data.keywords = '';
            $scope.params.PersonalMaterialId = route.PERSONALMATERIALID;
            $scope.data.currFileId = route.PERSONALMATERIALID;
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            requestData();
        }
        /**
         * [search description] 搜索
         * @param  {[type]} ev [description] 键盘按键
         * @return {[type]}    [description]
         */
        $scope.search = function(ev) {
            // if ((angular.isDefined(ev) && ev.keyCode == 13) || ev == 1) {
            var num = 0;
            var last = false;
            adjustWidth(num, last);
            $scope.params.searchValue = angular.copy($scope.data.keywords);
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            $scope.data.keyWords = $scope.data.keywords;
            requestData();
            // }
        };
        /**
         * [changeNav description] 切换标签
         * @param  {[type]} nav [description] 标签数据
         * @return {[type]}    [description]
         */
        $scope.changeNav = function(nav) {
            $scope.data.selectedNav = nav.value;
            $scope.data.keyWords = $scope.data.keywords = '';
            if (nav.value == '2') {
                getContentHeight();
            }
        };
        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        //列表单选框 点击选中
        $scope.selectDoc = function(item) {
            if (!$scope.picChecked(item)) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };
        $scope.picChecked = function(item) {
            for (var i in $scope.data.selectedArray) {
                var item_ = $scope.data.selectedArray[i];
                if (item_.PERSONALMATERIALID === item.PERSONALMATERIALID) {
                    return true;
                }
            }
            return false;
        };
        /**
         * [selectPic description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        //列表单选框 点击选中
        $scope.selectPic = function(file) {
            file.isSelected = !file.isSelected;
        };

        /**
         * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findChildrenFile = function(item) {
            if (item.FILETYPE == '0') {
                $scope.params.searchValue = '';
                $scope.params.PersonalMaterialId = item.PERSONALMATERIALID;
                $scope.data.currFileId = item.PERSONALMATERIALID;
                $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.copyCurrPage = 1;
                $scope.data.keyWords = $scope.data.keywords = '';
                requestData();
            }
        };
        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
            $('.uploadRsource .body').animate({ scrollTop: 0 }, 'fast');
        };
        /**
         * [getuploaderData description]获得图片上传后的路径和文件名
         * @param  {[ob]} src  [description]图片上传后的地址
         * @param  {[obj]} file [description]图片队列
         * @return {[type]}      [description]
         */
        function getuploaderData(src, file, i) {
            var deferred = $q.defer();
            $scope.data.uploadImgs[i].PERPICURL = src.imgSrc;
            $scope.data.uploadImgs[i].APPFILE = src.imgName;
            $scope.data.uploadImgs[i].APPDESC = file.name.replace(/\.\w+$/, '');
            $scope.data.uploadImgs[i].PERPICURL = src.imgSrc;
            $scope.data.uploadImgs[i].APPSIZE = src.fileSizeOfKB;
            $scope.data.uploadImgs[i].error = src.error;
            // $scope.data.uploadedSrcs.push({
            //     'PERPICURL': src.imgSrc,
            //     'APPFILE': src.imgName,
            //     'APPDESC': file.name.replace(/\.\w+$/, ''),
            //     'APPSORT': file.id.substr(file.id.length - 1, 1),
            //     'APPSIZE': src.fileSizeOfKB
            // });
            deferred.resolve($scope.data.uploadedSrcs);
            return deferred.promise;
        }
        /**
         * [getPicsSize] 获取选中图片的总大小
         * @return {[type]} [description]
         */
        $scope.getPicsSize = function() {
            return (function() {
                var size = 0;
                for (var i = 0; i < $scope.data.uploadImgs.length; i++) {
                    size += $scope.data.uploadImgs[i].size;
                }
                return Math.round((size / 1024 / 1024) * 100) / 100;
            })();
        };
        /**
         * [reUpload ]替换上传失败的图片
         * @return {[type]} [description]
         */
        $scope.reUpload = function(index, id) {
            $scope.errorIndex = index;
            $scope.errorId = id;
            $scope.status.file[0].click();
            // initInputFile(index, id);
        };
        /**
         * [initInputFile description] 初始化文件上传
         * @return {[type]} [description]
         */
        function initInputFile() {
            $scope.status.file = $(document.createElement('input'));
            $scope.status.file.attr({
                type: 'file',
                name: 'file',
                class: 'webuploader-element-invisible',
                multiple: false,
                accept: '.gif,.jpg,.jpeg,.bmp,.png,.webp,.eps',
            });
            $scope.status.file[0].onchange = function(index, id) {
                var self = this;
                $timeout(function() {
                    if (self.files[0].type.split('/')[0] == 'image' || self.files[i].type == 'application/postscript') {
                        $scope.data.uploadImgs[$scope.errorIndex] = self.files[0];
                        $scope.data.uploadImgs[$scope.errorIndex].id = $scope.errorId;
                        $scope.data.uploadImgs[$scope.errorIndex].APPDESC = self.files[0].name;
                        $scope.uploadPics($scope.errorIndex, $scope.errorId);
                    } else {
                        modalDialog.alertType('请上传符合格式要求的文件', '', 'error', 'confirm');
                    }
                    initInputFile($scope.errorIndex, $scope.errorId);
                });
            };
        }
        /**
         * [uploadPics] 开始上传图片
         * @return {[type]} [description]
         */
        $scope.uploadPics = function(index, id) {
            getFileMD5Service.getMd5($scope.data.uploadImgs[index]).then(function(md5) {
                uploadPic(
                    $scope.data.uploadImgs[index],
                    md5,
                    index,
                    function(data, index) {
                        // $timeout(function() {
                        $scope.$apply(function() {
                            $scope.data.progress[id] = Math.round((data.loaded / data.total) * 100) + '%';
                            $scope.data.proGress[id] = Math.round((data.loaded / data.total) * 100);
                        });
                        // });
                    },
                    function(data, index) {
                        $scope.$apply(function() {
                            if (angular.isDefined(JSON.parse(data).error)) {
                                modalDialog.alertType(JSON.parse(data).error, '', 'error', 'confirm');
                                $scope.data.uploadImgs[$scope.errorIndex].error = JSON.parse(data).error;
                                return;
                            } else {
                                $scope.data.uploadImgs[$scope.errorIndex].src = JSON.parse(data).imgSrc;
                                $scope.data.uploadImgs[$scope.errorIndex].APPFILE = JSON.parse(data).imgName;
                            }
                            $scope.data.uploadImgs[index].PERPICURL = '/wcm/app/system/read_image.jsp?FileName=' + JSON.parse(data).imgName;
                        });
                    },
                    function(data, index) {
                        $scope.data.uploadImgs[$scope.errorIndex].error = data;
                    }
                );
            });
        };
        /**
         * [uploadPic] 上传图片
         * $param {[fn]} onProgress 上传进度回调函数
         * @param {[fn]} onload [description] 上传完成回调函数
         * @return {[type]} [description]
         */
        function uploadPic(fileInfo, md5, index, onProgress, onload, onerror) {
            if (fileInfo.size / 1024 / 1024 > $scope.status.maxSize) {
                onerror('图片不能超过' + $scope.status.maxSize + 'M', index);
                return false;
            }
            var fd = new FormData();
            fd.append('file', fileInfo);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/wcm/openapi/uploadImage?md5=' + md5, true);
            xhr.onload = function(evt) {
                onload(evt.currentTarget.responseText, index);
                //console.log(evt.currentTarget.responseText);
            };
            xhr.onerror = function(evt) {
                onerror('上传失败，请重新上传', index);
            };
            xhr.upload.onprogress = function(evt) {
                //console.log("进度条");
                //console.log(evt);
                onProgress(evt, index);
            };
            xhr.upload.onloadstart = function() {
                //console.log("开始传了");
            };
            xhr.onreadystatechange = function() {
                //回调函数
                var status = xhr.readyState;
                if (status == 4 && xhr.status == 200) {
                    var b = xhr.responseText;
                    if (b) {
                    } else {
                    }
                }
            };
            xhr.send(fd);
        }
        /**
         * [getPreviewUrl ]获取图片预览地址
         * @params {[object]} item [description] 图片文件对象
         * @return {[type]} [description]
         */
        $scope.getPreviewUrl = function(item) {
            // if (!!item.isPersonalPic) {
            // return;
            // } else {
            // item.previewSrc = URL.createObjectURL(item);
            // }
        };
        /**
         * [addMyPictures description] 添加我的图片
         * @param {[type]} uploadPic [description]
         */
        function addMyPictures() {
            if ($scope.data.selectedArray.length > 0) {
                for (var l = 0; l < $scope.data.selectedArray.length; l++) {
                    $scope.data.uploadImgs.push({
                        PERPICURL: $scope.data.selectedArray[l].SRCIMGURL,
                        APPFILE: $scope.data.selectedArray[l].FILENAME,
                        APPDESC: $scope.data.selectedArray[l].FILEDESC.replace(/\.\w+$/, ''),
                        APPSORT: 1000 + l,
                        APPSIZE: $scope.data.selectedArray[l].FILESIZE,
                    });
                }
            }
        }
        /**
         * [isSavePersonal description]是否储存到个人素材
         * @return {Boolean} [description]
         */
        function isSavePersonal() {
            if ($scope.status.isAddPersonalMaterial == true && $scope.status.showAddPersonalMaterial) {
                var newIsPersonal = new Array();
                var isPersonal = angular.copy($scope.data.uploadImgs);
                for (var i = 0; i < isPersonal.length; i++) {
                    if (!isPersonal[i]) continue;
                    var obj = {};
                    obj.fileDesc = isPersonal[i].APPDESC;
                    obj.PersonalMaterialId = '0';
                    obj.fileSize = String(isPersonal[i].APPSIZE);
                    obj.fileName = isPersonal[i].APPFILE;
                    newIsPersonal.push(obj);
                }
                var params = {
                    methodname: 'addPersonalMaterialOfImgs',
                    serviceid: 'mlf_releaseSource',
                    PersonalMaterialOfImgs: JSON.stringify(newIsPersonal),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {});
            }
        }
        /**
         * [isAddPersonalMaterial description]是否保存至个人素材库
         * @return {Boolean} [description]
         */
        $scope.isAddPersonalMaterial = function() {
            $scope.status.isAddPersonalMaterial = !$scope.status.isAddPersonalMaterial;
        };
        /**
         * [finish description] 完成
         * @return {[type]} [description]
         */
        $scope.finish = function() {
            addMyPictures();
            isSavePersonal();
            var len = $scope.data.uploadImgs.length;
            for (var i = len - 1; i >= 0; i--) {
                if (angular.isDefined($scope.data.uploadImgs[i].error)) {
                    $scope.data.uploadImgs.splice(i, 1);
                }
            }
            $modalInstance.close($scope.data.uploadImgs);
            $('.modal.multiImgsUploader').remove();
        };
        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss('cancel');
            $('.modal.multiImgsUploader').remove();
        };
    },
]);
